/* eslint-disable max-lines-per-function */
import { ReactElement } from 'react';
import { Trans } from 'react-i18next';

import { LogoutDropdownItem, useSessionState } from '@dreryk/egabinet-security-frontend';
import {
   Dropdown,
   LinkIconVariant,
   LinkVariant,
   PersonIcon,
   StyledFlex,
   Text,
   usePush,
} from '@dreryk/react-components';
import { isDemo } from '@dreryk/demo-variant-frontend';

import { protectFeature } from '~libs.shared.system';
import { MyOrganizationDropdownItem, MyPracticeDropdownItem } from '~legacy.p1';
import { getMyAccountPath } from '~legacy.personnel';
import { PrivateMedicalServiceViewDropdownItem } from '~legacy.private-medical-service';
import { useGetCurrentPractitionerGlobalState, useResourceBranchByHealthcareProviderType } from '~libs.shared.account';

import { useFlushAccountVerificationState } from '../features/accountConfigurationInfo/accountConfigurationInfo.hooks';
import { useFlushPractitionerVerificationState } from '../features/accountConfigurationInfo/practitioner/practitionerAccountConfigurationInfo.hooks';
import { appTranslationKeys, userDropdownTranslationKeys } from '../translations';

import { StyledText, StyledUserDropdown } from './UserDropdown.styled';

export const SCHEDULE_PATH = '/harmonogram';
export const SETTINGS_PATH = '/ustawienia';
export const SYSTEM_ACTIVITY_PATH = '/aktywnosc-systemowa';

export const UserDropdown = (): ReactElement => {
   // TODO DREGAB-25028 Przeniesienie funkcjonalność integracji z Pharmindexem do panelu support
   const { account } = useSessionState();
   const currentPractitioner = useGetCurrentPractitionerGlobalState();
   const push = usePush();
   const flushAccountVerificationState = useFlushAccountVerificationState();
   const flushPractitionerVerificationState = useFlushPractitionerVerificationState();
   /*
    * TODO DREGAB-25028 Przeniesienie funkcjonalność integracji z Pharmindexem do panelu support
    * const displayName = `${currentPractitioner.firstName.asString()} ${currentPractitioner.lastName.asString()}`;
    */

   return (
      <StyledUserDropdown
         testId={'currentUserDropdown'}
         triggerIcon={<PersonIcon />}
         triggerLabel={
            <StyledFlex direction={'column'}>
               <Text testId={'fullName'}>{account?.displayName}</Text>
               {currentPractitioner ? (
                  <StyledText testId={'identifier'}>
                     <Trans
                        i18nKey={appTranslationKeys.identifier}
                        values={{ id: currentPractitioner.clientIdentifier }}
                     />
                  </StyledText>
               ) : null}
            </StyledFlex>
         }
         variant={LinkVariant.SECONDARY}
         triggerIconSuffixVariant={LinkIconVariant.SECONDARY}
      >
         <Dropdown.Item
            testId={'myAccount'}
            onClick={(hide) => {
               push(getMyAccountPath());
               hide();
            }}
         >
            {userDropdownTranslationKeys.myAccount}
         </Dropdown.Item>
         {protectFeature(
            'updatingProviderData',
            useResourceBranchByHealthcareProviderType(<MyOrganizationDropdownItem />, <MyPracticeDropdownItem />),
            null
         )}
         {protectFeature('managingPrivateMedicalServices', <PrivateMedicalServiceViewDropdownItem />, null)}
         {protectFeature(
            'updatingAvailability',
            <Dropdown.Item
               testId={'schedule'}
               onClick={(hide) => {
                  push(SCHEDULE_PATH);
                  hide();
               }}
            >
               {userDropdownTranslationKeys.schedule}
            </Dropdown.Item>,
            null
         )}
         {protectFeature(
            'creatingVisits',
            <Dropdown.Item
               testId={'templates'}
               onClick={(hide) => {
                  push(SETTINGS_PATH);
                  hide();
               }}
            >
               {userDropdownTranslationKeys.templates}
            </Dropdown.Item>,
            null
         )}
         {isDemo()
            ? null
            : protectFeature(
                 ['updatingProviderData'],
                 <Dropdown.Item
                    testId={'systemActivity'}
                    onClick={(hide) => {
                       push(SYSTEM_ACTIVITY_PATH);
                       hide();
                    }}
                 >
                    {userDropdownTranslationKeys.systemActivity}
                 </Dropdown.Item>,
                 null
              )}

         <LogoutDropdownItem
            onLogout={() => {
               flushAccountVerificationState();
               flushPractitionerVerificationState();
            }}
         />
      </StyledUserDropdown>
   );
};
